export const styles = () => ({
  importMessage: {
    wordBreak: 'break-word',
    paddingTop: 5,
    paddingBottom: 5,
  },
});
